import { faSack } from '@fortawesome/pro-regular-svg-icons/faSack'
import { Flex, Text, Progress } from '@mantine/core'
import { useRouter } from 'next/router'

import { useAppSelector } from '@flecto-io/core'
import { useAnalytics } from '@flecto/analytics'
import { useQueryGetBookingById } from '@flecto/core/saas'
import { useTranslation } from '@flecto/translations'
import {
  BadgeBookingPaymentRentalStatus,
  BoxCollapsible,
  TextCurrency,
} from '@flecto/ui'
import { Icon } from '@flecto/ui'

import { useModalBookingPayments } from '../../../../../../booking-payments'
import ViewPayments from '../../../../../../bookings/@legacy/Bookings/modules/Create/components/ViewPayments'
import DepositOverviewCard from './DepositOverviewCard'

export const PaymentRental = () => {
  const router = useRouter()
  const id = String(router.query?.id)

  const { t: tBooking } = useTranslation('saas', { keyPrefix: 'booking' })
  const { t: tCreateBooking } = useTranslation('saas', {
    keyPrefix: 'create-booking-payments',
  })

  const track = useAnalytics('segment')

  const { openModal } = useModalBookingPayments({ bookingId: id })

  const { historyPayments } = useAppSelector((state) => ({
    historyPayments: state.bookings.createBooking.historyPayments.data,
  }))

  const { data: booking } = useQueryGetBookingById({ bookingId: id })

  const handleOpenHistoryPayment = () => {
    openModal()
    track('BOOKING_PAYMENT__VIEW_ALL', {
      booking_id: id,
    })
  }

  const rentalPaidCents = booking?.meta?.rental_paid_cents ?? 0
  const rentalTotalCents = booking?.meta?.rental_total_cents ?? 0
  const isRentalOverpaid =
    booking?.meta?.payment_rental_status === 'payment_rental_overpaid'

  const rentalPercent = (rentalPaidCents * 100) / rentalTotalCents

  return (
    <BoxCollapsible
      title={tBooking('create-booking.booking_payments.title')}
      viewAll={historyPayments.length ? handleOpenHistoryPayment : undefined}
    >
      <Flex gap='sm' wrap='nowrap' align='center' justify='space-between'>
        <Flex align='center' gap='sm'>
          <Icon icon={faSack} size='sm' withCircleBackground />
          <Text fw={500}>
            {tBooking('create-booking.booking_payments.rental')}
          </Text>
        </Flex>
        <BadgeBookingPaymentRentalStatus booking={booking} />
      </Flex>
      <Flex mt='md' align='flex-start' direction='column'>
        <Flex align='baseline' gap='xs'>
          <TextCurrency
            fw={500}
            cents={
              isRentalOverpaid
                ? rentalPaidCents - rentalTotalCents
                : rentalTotalCents - rentalPaidCents
            }
          />
          <Text color='dimmed' size='sm'>
            {isRentalOverpaid
              ? tCreateBooking('amount_to_return')
              : tCreateBooking('amount_to_receive')}
          </Text>
        </Flex>
        <Progress
          mt='xs'
          w='100%'
          color={isRentalOverpaid ? 'red' : 'green'}
          value={isRentalOverpaid ? 100 : rentalPercent}
        />
      </Flex>

      {booking?.meta?.payment_deposit_status &&
        String(booking?.meta.payment_deposit_status) !==
          'payment_deposit_no_deposit' && <DepositOverviewCard />}
      <ViewPayments canRegisterPayment />
    </BoxCollapsible>
  )
}

export default PaymentRental
